"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v4_1 = __importDefault(require("uuid/v4"));

var store_1 = require("../store");

var AnalyticsProviderAbstract =
/** @class */
function () {
  function AnalyticsProviderAbstract(actionsMap) {
    this.actionsMap = actionsMap;
    this.appName = 'StudentAptitude';
    this.personId = '';
    this.dispatch = null;
  }

  AnalyticsProviderAbstract.prototype.generateId = function () {
    return v4_1.default();
  };

  AnalyticsProviderAbstract.prototype.mapRecordAnalyticsPayload = function (payload) {
    var data = payload.data,
        action = payload.action,
        actionOn = payload.actionOn,
        actionType = payload.actionType,
        personId = payload.personId,
        sessionId = payload.sessionId;
    return {
      id: this.generateId(),
      SessionId: sessionId,
      PersonId: personId,
      App: this.appName,
      Action: action,
      ActionOn: actionOn,
      ActionType: actionType,
      AdditionalDataJson: JSON.stringify(data)
    };
  };

  AnalyticsProviderAbstract.prototype.recordData = function (data) {
    var payload = this.mapRecordAnalyticsPayload(data); // tslint:disable-next-line: no-unused-expression

    this.dispatch && this.dispatch(store_1.recordAnalyticsDataActionActionCreator(payload));
  };

  return AnalyticsProviderAbstract;
}();

exports.AnalyticsProviderAbstract = AnalyticsProviderAbstract;